import styled from 'styled-components';

export const StackedBarContainer = styled.div`
  width: 100%;
  min-height: 380px;
`;

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LegendSwatch = styled.div<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 4px;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;
